export default "__VITE_ASSET__BvixXtI8__"